const firebaseConfig = {
  apiKey: "AIzaSyBdeUvqLWGu1CWtPjGl_ttB8cwyZlvfjNs",
  authDomain: "labayhapp-e7163.firebaseapp.com",
  databaseURL: "https://labayhapp-e7163.europe-west1.firebasedatabase.app",
  projectId: "labayhapp-e7163",
  storageBucket: "labayhapp-e7163.appspot.com",
  messagingSenderId: "977729905378",
  appId: "1:977729905378:web:82a8230428350ecd",
};

const isStaging = true;
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
const keysUrl = process.env.NEXT_PUBLIC_KEYS_PATH;
const yaqeenApi = process.env.NEXT_PUBLIC_YAQEEN_API;
const agoraAppId = process.env.NEXT_PUBLIC_AGORA_APP_ID;
const apiKey = process.env.NEXT_PUBLIC_LABAYH_API_KEY;
const applePayMarchantId = process.env.NEXT_PUBLIC_APPLE_PAY_MARCHANT_ID;
const twilioToken = process.env.NEXT_PUBLIC_TWILIO_TOKEN;

export {
  agoraAppId,
  apiKey,
  baseUrl,
  firebaseConfig,
  isStaging,
  keysUrl,
  yaqeenApi,
  applePayMarchantId,
  twilioToken,
};
